
import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Label,
    Alert, InputGroup, InputGroupText
} from "reactstrap";
import { BASE_URL } from "../../constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Hide from '../../assets/img/icon/hide.png'
import View from '../../assets/img/icon/view.png'

function ProfileDetails() {
    // const { userData } = useContext(AppContext);

    const userData = JSON.parse(localStorage.getItem('userData'));

    console.log(userData?.subscriptionPackage, 'dog')
    const navigate = useNavigate();
    const [errMsg, setErrMsg] = useState(null);
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [visibleCurrent, setVisibleCurrent] = useState(false);
    const [visibleNew, setVisibleNew] = useState(false);
    const [visibleConfirm, setVisibleConfirm] = useState(false);

    const [formData, setFormData] = useState({
        email: '',
        phone: '',
        first_name: '',
        last_name: '',
        address: '',
        address_line_2: '',
        country: '',
        city: '',
        state: '',
        zip: '',
        dp: null
    });

    console.log(formData, 'formData')
    const [imageUrl, setImageUrl] = useState(null);

    console.log(currentPassword, newPassword, confirmPassword, 'kom')

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        if (name === 'currentPassword') setCurrentPassword(value);
        if (name === 'newPassword') setNewPassword(value);
        if (name === 'confirmPassword') setConfirmPassword(value);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            dp: e.target.files[0]
        });

        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setImageUrl(reader.result);
        };
        reader.readAsDataURL(file);
    };

    useEffect(() => {
        // if (userData) {
        //     setFormData({
        //         email: userData.email || '',
        //         phone: userData.phone || '',
        //         firstName: userData.first_name || '',
        //         lastName: userData.last_name || '',
        //         address: userData.address || '',
        //         addressLine2: userData.addressLine2 || '',
        //         country: userData.country || '',
        //         city: userData.city || '',
        //         state: userData.state || '',
        //         zip: userData.zip || '',
        //     });
        // }

        const token = localStorage.getItem('token');
        if (token) {
            fetch(`${BASE_URL}/auth/profile`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data, 'mno');
                    if (data.status) {
                        // setFormData(data.result);
                        setFormData({
                            email: data.result.email || '',
                            phone: data.result.phone || '',
                            first_name: data.result.first_name || '',
                            last_name: data.result.last_name || '',
                            address: data.result.address || '',
                            address_line_2: data.result.address_line_2 || '',
                            country: data.result.country || '',
                            city: data.result.city || '',
                            state: data.result.state || '',
                            zip: data.result.zip || '',
                            dp: data.result.dp
                        });
                    } else {
                        console.error("Error: Unable to fetch data.");
                    }
                })
                .catch(error => console.error("Error fetching data:", error));
        } else {
            console.error("Error: Authorization token is missing.");
        }

    }, []);

    const handleUpdate = () => {
        navigate('/packages')
    };

    const handleCancel = async () => {

        const confirmed = window.confirm("Are you sure you want to cancel the subscription?");
        if (confirmed) {
            try {

                const token = localStorage.getItem('token');
                if (!token) {
                    throw new Error('Authorization token is missing.');
                }

                const response = await axios.delete(`${BASE_URL}/subscription/cancel`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });

                if (userData) {
                    delete userData.subscriptionPackage;

                    localStorage.setItem('userData', JSON.stringify(userData));
                }

                console.log('Subscription cancelled successfully:', response.data);
                setErrMsg(response.data.message);

            } catch (error) {
                const errorMessage = error.response?.data?.message || 'An error occurred while cancelling the subscription';
                setErrMsg(errorMessage);
            }
        }
    };



    const handleSubmit = async (e) => {
        console.log('peter')
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Authorization token is missing.');
            }

            const newFormData = new FormData();
            newFormData.append('first_name', formData.first_name);
            newFormData.append('last_name', formData.last_name);
            newFormData.append('phone', formData.phone);
            newFormData.append('email', formData.email);

            newFormData.append('address', formData.address);
            newFormData.append('address_line_2', formData.address_line_2);
            newFormData.append('country', formData.country);
            newFormData.append('city', formData.city);
            newFormData.append('state', formData.state);
            newFormData.append('zip', formData.zip);


            if (formData.dp) {
                newFormData.append('dp', formData.dp);
            }

            const response = await axios.post(`${BASE_URL}/auth/update-profile`, newFormData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.data.status) {
                setErrMsg(response.data.message);
            }
            else {
                setErrMsg(response.data.message);
            }
        } catch (error) {
            setErrMsg(error);
        }
    };


    const handlePasswordSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem('token');
            if (!token) {
                throw new Error('Authorization token is missing.');
            }

            const response = await axios.post(`${BASE_URL}/auth/update-password`, {
                password: currentPassword,
                confirm_password: confirmPassword,
                new_password: newPassword
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            console.log(response.data, 'shamp')
            if (response.data.status) {
                setErrMsg(response.data.message);
                setCurrentPassword('');
                setNewPassword('');
                setConfirmPassword('');
            }
            else {
                setErrMsg(response.data.message);
            }
        } catch (error) {
            setErrMsg(error);
        }

    };

    return (
        <>
            <div className="content">
                {errMsg && <Alert color="danger">{errMsg}</Alert>}

                <Row>
                    <Col md="4">
                        <Card className="card-user">
                            <div className="image">
                            </div>
                            <CardBody>
                                <div className="author">
                                    {imageUrl ? (
                                        <img src={imageUrl} alt="Selected" style={{ maxWidth: '100%', maxHeight: '200px' }} />
                                    ) : (
                                        formData?.dp && <img src={formData?.dp} alt="dp" />
                                    )}
                                    <h5 style={{ marginTop: '30px' }} className="title">{formData?.first_name} {formData?.last_name}</h5>
                                </div>
                                {userData?.subscriptionPackage &&
                                    < div className="text-center mt-5 p-3" style={{ backgroundColor: '#f4f5f7', borderRadius: '8px' }}>
                                        <h6 className="font-weight-bold">{userData?.subscriptionPackage?.title}</h6>
                                        <p className="mb-1">Allowed Properties: <span>{userData?.subscriptionPackage?.allowed_properties}</span></p>
                                        <p className="mb-1">Allowed Users: <span>{userData?.subscriptionPackage?.allowed_users}</span></p>
                                        <div className="d-flex justify-content-center mt-4">
                                        {userData?.subscriptionPackage?.is_trial_package === 0 && userData?.subscriptionPackage?.type === 'STRIPE' &&
                                            <Button color="danger" onClick={handleCancel}>Cancel</Button>

                                        }
                                            <Button color="primary" onClick={handleUpdate} style={{ marginLeft: '10px' }}>Update</Button>
                                        </div>
                                    </div>
                                }
                            </CardBody>

                        </Card>

                    </Col>
                    <Col md="8">
                        <Card className="card-user">
                            <CardHeader>
                                <CardTitle tag="h5">Edit Profile</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs="6">
                                            <FormGroup>
                                                <Label for="email">Email*</Label>
                                                <Input
                                                    type="email"
                                                    name="email"
                                                    id="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    disabled={true}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="6">
                                            <FormGroup>
                                                <Label for="phone">Phone</Label>
                                                <Input
                                                    type="number"
                                                    name="phone"
                                                    id="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="6">
                                            <FormGroup>
                                                <Label for="first_name">First Name*</Label>
                                                <Input
                                                    type="text"
                                                    name="first_name"
                                                    id="first_name"
                                                    value={formData.first_name}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs="6">
                                            <FormGroup>
                                                <Label for="last_name">Last Name*</Label>
                                                <Input
                                                    type="text"
                                                    name="last_name"
                                                    id="last_name"
                                                    value={formData.last_name}
                                                    onChange={handleChange}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>

                                    {
                                        userData.type === 'OWNER' &&
                                        <>
                                            <Row>
                                                <Col xs="12">
                                                    <FormGroup>
                                                        <Label for="address">Address</Label>
                                                        <Input
                                                            type="text"
                                                            name="address"
                                                            id="address"
                                                            value={formData.address}
                                                            onChange={handleChange}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="12">
                                                    <FormGroup>
                                                        <Label for="address_line_2">Address Line 2</Label>
                                                        <Input
                                                            type="text"
                                                            name="address_line_2"
                                                            id="address_line_2"
                                                            value={formData.address_line_2}
                                                            onChange={handleChange}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>

                                            <Row>
                                                <Col xs="6">
                                                    <FormGroup>
                                                        <Label for="country">Country</Label>
                                                        <Input
                                                            type="text"
                                                            name="country"
                                                            id="country"
                                                            value={formData.country}
                                                            onChange={handleChange}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="6">
                                                    <FormGroup>
                                                        <Label for="city">City</Label>
                                                        <Input
                                                            type="text"
                                                            name="city"
                                                            id="city"
                                                            value={formData.city}
                                                            onChange={handleChange}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="6">
                                                    <FormGroup>
                                                        <Label for="state">State</Label>
                                                        <Input
                                                            type="text"
                                                            name="state"
                                                            id="state"
                                                            value={formData.state}
                                                            onChange={handleChange}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="6">
                                                    <FormGroup>
                                                        <Label for="zip">Zip</Label>
                                                        <Input
                                                            type="text"
                                                            name="zip"
                                                            id="zip"
                                                            value={formData.zip}
                                                            onChange={handleChange}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    <Row>
                                        <Col xs="12">
                                            <FormGroup>
                                                <Label for="dp">Profile Picture</Label>
                                                <Input type="file" name="dp" id="dp" onChange={handleFileChange} />
                                            </FormGroup>
                                        </Col>
                                    </Row>


                                    <Row>
                                        <div className="update ml-auto mr-auto">
                                            <Button
                                                color="primary" type="submit"
                                            >
                                                Update Profile
                                            </Button>
                                        </div>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>

                        <Card className="card-user">
                            <CardHeader>
                                <CardTitle tag="h5">Change Password</CardTitle>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handlePasswordSubmit}>
                                    <Row>
                                        <Col xs="6">
                                            <FormGroup>
                                                <Label for="currentPassword">Current Password</Label>
                                                <InputGroup>
                                                    <Input
                                                        type={visibleCurrent ? "text" : "password"}
                                                        name="currentPassword"
                                                        id="currentPassword"
                                                        value={currentPassword}
                                                        onChange={handlePasswordChange}
                                                        className="form-control user-select-none"
                                                    />
                                                    <InputGroupText
                                                        onClick={() => setVisibleCurrent(!visibleCurrent)}
                                                        className="user-select-none"
                                                    >
                                                        {visibleCurrent ? (
                                                            <img src={View} alt="Show" height={20} draggable="false" />
                                                        ) : (
                                                            <img src={Hide} alt="Hide" height={20} draggable="false" />
                                                        )}
                                                    </InputGroupText>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col xs="6">

                                            <FormGroup>
                                                <Label for="newPassword">New Password</Label>
                                                <InputGroup>
                                                    <Input
                                                        type={visibleNew ? "text" : "password"}
                                                        name="newPassword"
                                                        id="newPassword"
                                                        value={newPassword}
                                                        onChange={handlePasswordChange}
                                                        className="form-control user-select-none"
                                                    />
                                                    <InputGroupText
                                                        onClick={() => setVisibleNew(!visibleNew)}
                                                        className="user-select-none"
                                                    >
                                                        {visibleNew ? (
                                                            <img src={View} alt="Show" height={20} draggable="false" />
                                                        ) : (
                                                            <img src={Hide} alt="Hide" height={20} draggable="false" />
                                                        )}
                                                    </InputGroupText>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="6">
                                            <FormGroup>
                                                <Label for="confirmPassword">Confirm Password</Label>
                                                <InputGroup>
                                                    <Input
                                                        type={visibleConfirm ? "text" : "password"}
                                                        name="confirmPassword"
                                                        id="confirmPassword"
                                                        value={confirmPassword}
                                                        onChange={handlePasswordChange}
                                                        className="form-control user-select-none"
                                                    />
                                                    <InputGroupText
                                                        onClick={() => setVisibleConfirm(!visibleConfirm)}
                                                        className="user-select-none"
                                                    >
                                                        {visibleConfirm ? (
                                                            <img src={View} alt="Show" height={20} draggable="false" />
                                                        ) : (
                                                            <img src={Hide} alt="Hide" height={20} draggable="false" />
                                                        )}
                                                    </InputGroupText>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <div className="update ml-auto mr-auto">
                                            <Button color="primary" type="submit">
                                                Update Password
                                            </Button>
                                        </div>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>


                        <Card >
                            <CardHeader>
                                <CardTitle tag="h5">Delete Account</CardTitle>
                            </CardHeader>
                            <CardBody>
                            Deleting your account is permanent and cannot be undone. All your data will be removed.
                                <Row>
                                    <div className="update ml-auto mr-auto mt-2">
                                        <Button
                                            color="primary"
                                            onClick={() => navigate('/request-account-deletion')                                            }
                                        >
                                            Delete Account
                                        </Button>
                                    </div>
                                </Row>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
            </div >
        </>
    );
}

export default ProfileDetails;
